<template>
	<swiper
		class="swiper"
		:slides-per-view="1"
		:space-between="12"
		:modules="modules"
		prevent-interaction-on-transition
		:pagination="{ clickable: true, el: '.custom-pagination' }"
		:navigation="{
			enabled: pagination || navigation,
			nextEl: '.button-next',
			prevEl: '.button-prev',
			disabledClass: 'button-disabled',
		}"
		:mousewheel="{
			// enabled: true,
			releaseOnEdges: true,
			sensitivity: 0.5,
			forceToAxis: true,
			thresholdDelta: 10,
			thresholdTime: 500,
		}"
		:rewind="false"
		:free-mode="false"
		:breakpoints="breakpoints ?? defaultBreakpoints"
		v-bind="$attrs">
		<!-- SwiperSlide -->
		<slot />

		<!-- <SwiperSlide v-else v-for="i in 5" :key="i" class="skeleton-slide">
			<Skeleton class="skeleton-img" height="300px" />
			<Skeleton class="skeleton-title" height="40px" />
			<Skeleton class="skeleton-text" height="10px" width="60%" />
			<Skeleton class="skeleton-text" height="10px" width="40%" />
			<Skeleton class="skeleton-text" height="10px" width="40%" />
		</SwiperSlide> -->
		<!-- <UICarouselNavigation
			v-if="!customNavigation"
			:pagination="pagination"
			:navigation="navigation"
			:next-icon="nextIcon"
			:prev-icon="prevIcon" /> -->
	</swiper>
</template>

<script setup lang="ts">
	import { Autoplay, Mousewheel, Navigation, Pagination, Parallax } from 'swiper/modules'

	const defaultBreakpoints = {
		0: {
			slidesPerView: 1,
		},
		576: {
			slidesPerView: 1.5,
		},
		768: {
			slidesPerView: 2,
		},
		992: {
			slidesPerView: 3,
		},
		// 1440: {
		// 	slidesPerView: 3.5,
		// },
	}

	interface IProps {
		pagination?: boolean
		navigation?: boolean
		prevIcon?: string
		nextIcon?: string
		customNavigation?: boolean
		breakpoints?: {
			[key: number]: {
				slidesPerView: number
			}
		} | null
	}

	withDefaults(defineProps<IProps>(), {
		pagination: false,
		navigation: true,
		prevIcon: 'mdi:arrow-left',
		nextIcon: 'mdi:arrow-right',
		breakpoints: null,
		customNavigation: false,
	})

	const modules = [Navigation, Mousewheel, Autoplay, Pagination, Parallax]
</script>
